// 语言管理
import http from "@/jslibs/axios/http";

// 新增语言
export const add = (data) => http.post("/cms/language/add", data);

// 编辑语言
export const edit = (data) => http.post("/cms/language/update", data);

// 语言详情
export const detail = (id) => http.get("/cms/language/details/" + id);

// 语言全量列表
export const list = (data) => http.get("/cms/language/list", data);

// 语言分页列表
export const page = (data) => http.get("/cms/language/page", data);

// 国家枚举列表
export const countryList = () => http.get("/cms/language/countryList");

// 语言删除
export const del = (id) => http.delete("/cms/language/" + id);
